export const CHANGE_CAMERA_SEVERAL_VALUES = 'CHANGE_CAMERA_SEVERAL_VALUES';
export const RESET_CAMERA_STORE = 'RESET_CAMERA_STORE';

export const changeCameraSeveralValues = values => ({
  type: CHANGE_CAMERA_SEVERAL_VALUES,
  payload: values,
});

export const resetStore = () => ({
  type: RESET_CAMERA_STORE,
});
